import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import { DOCUMENT_DOWNLOAD_CATEGORY_KEY, DOCUMENT_DOWNLOAD_COMPONENT_KEY } from '../DocumentDownload.meta.js';

// Set as a div to avoid a label being nested inside a label
export default InjectedStyledComponent('div', DOCUMENT_DOWNLOAD_CATEGORY_KEY, DOCUMENT_DOWNLOAD_COMPONENT_KEY, [
	'documentLabel',
]);
